<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Holiday"
}
</script>

<style scoped>

</style>